import { SignatureKind } from "client/Api/Email/common";
import { SignatureModel } from "client/Api/Email/email";
import create, { UseStore } from "zustand";
import createVanilla, { StoreApi } from "zustand/vanilla";

export type SignatureStoreData = {
	signatures: readonly SignatureModel[];
	setSignatures(signatures: readonly SignatureModel[]): void;
	addOrUpdate(signature: SignatureModel): void;
	remove(signatureKind: SignatureKind): void;
	setDefault(signatureKind: SignatureKind): void;
};

export const signatureStore: StoreApi<SignatureStoreData> = createVanilla<SignatureStoreData>(
	(set): SignatureStoreData => {
		return {
			signatures: [],
			setSignatures(signatures: readonly SignatureModel[]): void {
				set({ signatures });
			},
			addOrUpdate(signature: SignatureModel): void {
				set(state => {
					const signaturesCopy: SignatureModel[] = [...state.signatures];
					const existingItemIndex: number = signaturesCopy.findIndex(s => s.kind === signature.kind);

					if (existingItemIndex === -1) {
						signaturesCopy.push(signature);

						return {
							signatures: signaturesCopy
						};
					}

					signaturesCopy[existingItemIndex] = signature;

					return {
						signatures: signaturesCopy
					};
				});
			},
			remove(signatureKind: SignatureKind): void {
				set(
					state => ({
						signatures: state.signatures.filter(s => s.kind !== signatureKind)
					})
				);
			},
			setDefault(signatureKind: SignatureKind): void {
				set(
					state => {
						const result: SignatureModel[] = [];
						let hasChanges: boolean = false;

						for (const signature of state.signatures) {
							const shouldBeDefault: boolean = signature.kind === signatureKind;

							if (signature.isDefault === shouldBeDefault) {
								result.push(signature);
							} else {
								result.push({
									...signature,
									isDefault: signature.kind === signatureKind
								});
								hasChanges = true;
							}
						}

						if (!hasChanges) {
							return state;
						}

						return {
							...state,
							signatures: result
						};
					}
				);
			},
		};
	}
);

export const useSignatureStore: UseStore<SignatureStoreData> = create(signatureStore);